import moment from 'moment';

export const financialYears = [...new Array(moment().year() - 2020)].map(
  (_el, index) => `${moment().year() - index}-${moment().year() - index + 1}`
);

export const currentFinancialYear =
  moment().month() < 3 ? financialYears[1] : financialYears[0];
